import { axiosInstance } from '@/shared/api/axios';
import { SprsRetentionSettingGetResponseType } from '@/shared/types/api/api.sprsRetentionSetting';

export const getSprsRetentionSetting = async (): Promise<SprsRetentionSettingGetResponseType> => {
  const { data } = await axiosInstance.get<SprsRetentionSettingGetResponseType>(
    `/sprs-retention-settings`,
  );
  return data;
};
